// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1NBgU","buttons":"SendReceipts_buttons__14Ygu","email":"SendReceipts_email__1IQ4A","bookApptTitle":"SendReceipts_bookApptTitle__1UPto"};